import * as types from './types';
import { isServiceError } from '../../utils/errorCodes';

const initialState = {
  formValues: {
    title: '',
    description: '',
    code: '',
    titleAI: '',
    descriptionAI: ''
  },
  formValuesError: false,
  formValuesLoading: false,
  formValuesCompleted: false,
  suggestedDataError: null,
  suggestedDataLoading: false,
  suggestedDataCompleted: false
};

function stepDescriptionReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_FORM_VALUES:
      return { ...state, formValuesLoading: true, formValuesError: false };
    case types.GET_FORM_VALUES_COMPLETED:
      return {
        ...state,
        formValues: {
          title: action.payload.title,
          description: action.payload.description,
          code: action.payload.internal_code
        },
        formValuesLoading: false,
        formValuesCompleted: true
      };
    case types.GET_FORM_VALUES_FAILED:
      return {
        ...state,
        formValuesLoading: false,
        formValuesError: isServiceError(action?.payload?.status),
        formValuesCompleted: true
      };

    case types.SET_FORM_VALUES:
      return {
        ...state,
        formValues: {
          title: action.payload.title,
          description: action.payload.description,
          code: action.payload.code
        }
      };

    case types.GET_SUGGESTED_DATA:
      return {
        ...state,
        suggestedDataLoading: true,
        suggestedDataCompleted: false,
        suggestedDataError: false
      };
    case types.GET_SUGGESTED_DATA_COMPLETED:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          titleAI: action.payload.title,
          descriptionAI: action.payload.description
        },
        suggestedDataLoading: false,
        suggestedDataCompleted: true
      };
    case types.GET_SUGGESTED_DATA_FAILED:
      return {
        ...state,
        suggestedDataLoading: false,
        suggestedDataError: isServiceError(action?.payload?.status),
        suggestedDataCompleted: true
      };
    case types.RESET_SUGGESTED_DATA:
      return { suggestedDataError: null, suggestedDataCompleted: false };

    case types.RESET_INFO:
      return { ...initialState };
    default:
      return state;
  }
}

export { stepDescriptionReducer };
